import { PersonEmployeeNumberFragment } from "gql/graphql";
import { Hidable, Value } from "@/shared/value";

/** Табельный номер сотрудника — поле под защитой, поэтому показывается через `Value`. */
export function PersonEmployeeNumber({
  data,
}: {
  data?: Hidable<PersonEmployeeNumberFragment>;
}) {
  return (
    <Value data={data}>
      {(person) => <Value data={person.employeeNumber} />}
    </Value>
  );
}
